export default __webpack_public_path__ + "static/media/pending_metrics.71fcf67cc71e47ebcfc10c63e48e3edd.svg";